import { render } from "./InventoryModal.vue?vue&type=template&id=fc0d7980&scoped=true"
import script from "./InventoryModal.vue?vue&type=script&lang=js"
export * from "./InventoryModal.vue?vue&type=script&lang=js"

import "./InventoryModal.vue?vue&type=style&index=0&id=fc0d7980&scoped=true&lang=css"

import exportComponent from "/home/claude/weedborncounty/weedborncounty/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc0d7980"]])

export default __exports__